import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Zimmerservice',
      [RoomServiceLocationType.TableService]: 'Tischservice',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Türklingelname (optional)',
    },
    company_name: {
      placeholder: 'Firmenname (optional)',
    },
    customer_note: {
      placeholder: 'Lieferanweisungen (optional)',
    },
    order_instructions: {
      placeholder: 'Bestellanweisungen eingeben...',
    },
  },
};
